export enum CplUserStatus {
    NONE = -1,
    DEFAULT = 0,
    VERIFIED = 1,
    EXPIRING = 2,
    PENDING = 3,
    EXPIRED = 4,
    DELETED = 5,
    DECLINED = 6,
    FORGIVEN = 7,
    COMPLETE_NOTALL_APPROVED=8
}